<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            class="grid theme-dependent"
            noDataText=""
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [customizeColumns]="customizeColumns"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'email-templates-grid-state', savingTimeout: 0 }"
            (onExporting)="onExporting($event)"
            keyExpr="id"
            (onRowDblClick)="onRowDblClick($event)"
            width="100%"
        >
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Email Templates</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    widget="dxButton"
                    showText="inMenu"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
            </dxo-toolbar>

            <dxi-column [dataField]="gridFieldName('type')" caption="Type" [width]="350" cellTemplate="type"
                        [lookup]="{ dataSource: typeOptions, valueExpr: 'value', displayExpr: 'text', allowClearing: true }"
                        [headerFilter]="{ dataSource: typeOptions }"
            ></dxi-column>
            <dxi-column [dataField]="gridFieldName('subject')" caption="Subject" [minWidth]="300"></dxi-column>
            <dxi-column [dataField]="gridFieldName('lastModified')" caption="Last Modified" [minWidth]="150"
                        dataType="date"></dxi-column>
            <dxi-column [dataField]="'lastModifiedBy.name'" caption="Last Modified By" cellTemplate="employee" [minWidth]="300"
                        [calculateFilterExpression]="lastModifiedByFilter"></dxi-column>

            <dxi-column type="buttons" caption="Actions">
                <dxi-button text="edit" icon="edit" hint="edit" [onClick]="onEdit"></dxi-button>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'type'">
                {{ cellInfo.value | capitalCase }}
            </div>
            <div *dxTemplate="let cellInfo of 'employee'">
                @if (getCellData(cellInfo).lastModifiedBy) {
                    <user-avatar-email
                        [email]="getCellData(cellInfo).lastModifiedBy.email"
                        [name]="getCellData(cellInfo).lastModifiedBy.name"
                        [avatarUrl]="getCellData(cellInfo).lastModifiedBy.avatarUrl"
                        [employeeId]="getCellData(cellInfo).lastModifiedBy.id"
                    ></user-avatar-email>
                }
            </div>
        </dx-data-grid>
    </div>

    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="filterModelName('type')"
                editorType="dxSelectBox"
                [editorOptions]="{
                    placeholder: 'Type',
                    stylingMode: 'filled',
                    items: typeOptions,
                    valueExpr: 'value',
                    displayExpr: 'text'
                }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="filterModelName('subject')"
                editorType="dxTextBox"
                [editorOptions]="{placeholder: 'Subject',stylingMode: 'filled'}"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    <app-email-template-popup [(visible)]="isPopupOpened" (onUpdate)="onAdd()"
                              [request]="selectedRow"></app-email-template-popup>
</div>
